
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/story",
      function () {
        return require("private-next-pages/about/story.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/story"])
      });
    }
  